<template>
    <div class="card mt-3">
        <div class="card-body">
            <h5 class="card-title">MQTT Hostname</h5>
            <div class="form-group row">
                <div class="col-4">
                    <label class="col-form-label col-form-label-sm">Server Address</label>
                </div>
                <div class="col-md-8">
                    <input
                        type="text"
                        class="form-control form-control-sm"
                        :class="{ 'is-invalid': serverAddressError }"
                        v-model="serverData.mqtt.hostname"
                        @change="validateServerAddress" />
                    <div class="invalid-feedback">Please follow IP address or URL format</div>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-4">
                    <label class="col-form-label col-form-label-sm">MQTT Port Number</label>
                </div>
                <div class="col-md-8">
                    <input
                        type="text"
                        class="form-control form-control-sm"
                        :class="{ 'is-invalid': portNumberError }"
                        v-model="serverData.mqtt.portNumber"
                        @change="validatePort" />
                    <div class="invalid-feedback">Numbers ranging from 1 to 65535 only</div>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-4">
                    <label class="col-form-label col-form-label-sm">Username</label>
                </div>
                <div class="col-md-8">
                    <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="serverData.mqtt.username" />
                </div>
            </div>
            <div class="form-group row">
                <div class="col-4">
                    <label class="col-form-label col-form-label-sm">Password</label>
                </div>
                <div class="col-md-8">
                    <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="serverData.mqtt.password" />
                </div>
            </div>
            <div class="form-group row">
                <div class="col-4">
                    <label class="col-form-label col-form-label-sm">MQTT Client Topic Name</label>
                </div>
                <div class="col-md-8">
                    <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="serverData.mqtt.topicName" />
                </div>
            </div>
            <div class="form-group row">
                <div class="col-4">
                    <label class="col-form-label col-form-label-sm">QOS</label>
                </div>
                <div class="col-md-8">
                    <select
                        class="form-control form-control-sm"
                        v-model="serverData.mqtt.qos">
                        <option value="0">0</option>
                        <option value="1">1</option>
                        <option value="2">2</option>
                    </select>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-4">
                    <label class="col-form-label col-form-label-sm">FTP Server Address</label>
                </div>
                <div class="col-md-8">
                    <input
                        type="text"
                        class="form-control form-control-sm"
                        :class="{ 'is-invalid': ftpServerAddressError }"
                        v-model="serverData.mqtt.ftpServerAddress"
                        @change="validateFtpServerAddress" />
                    <div class="invalid-feedback">Please follow IP address format</div>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-4">
                    <label class="col-form-label col-form-label-sm">FTP Port Number</label>
                </div>
                <div class="col-md-8">
                    <input
                        type="text"
                        class="form-control form-control-sm"
                        :class="{ 'is-invalid': ftpPortNumberError }"
                        v-model="serverData.mqtt.ftpPortNumber"
                        @change="validateFtpPort" />
                    <div class="invalid-feedback">Numbers ranging from 1 to 65535 only</div>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-4">
                    <label class="col-form-label col-form-label-sm">FTP Username</label>
                </div>
                <div class="col-md-8">
                    <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="serverData.mqtt.ftpUsername" />
                </div>
            </div>
            <div class="form-group row">
                <div class="col-4">
                    <label class="col-form-label col-form-label-sm">FTP Password</label>
                </div>
                <div class="col-md-8">
                    <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="serverData.mqtt.ftpPassword" />
                </div>
            </div>
            <div class="form-group row">
                <div class="col-4">
                    <label class="col-form-label col-form-label-sm">FTP Config File Path</label>
                </div>
                <div class="col-md-8">
                    <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="serverData.mqtt.ftpConfigFilePath" />
                </div>
            </div>
            <div class="form-group row">
                <div class="col-4">
                    <label class="col-form-label col-form-label-sm">Send Data Mode</label>
                </div>
                <div class="col-md-8">
                    <select
                        class="form-control form-control-sm"
                        v-model="serverData.mqtt.senddatamode">
                        <option value="0">Old Data(Saved Data)</option>
                        <option value="1">Latest Data Only</option>
                    </select>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-4">
                    <label class="col-form-label col-form-label-sm">JSON Data View</label>
                </div>
                <div class="col-md-8">
                    <select
                        class="form-control form-control-sm"
                        v-model="serverData.mqtt.jsondataview">
                        <option value="0">JSON TO STRING PLAIN</option>
                        <option value="1">JSON TO STRING SPACED</option>
                        <option value="2">JSON TO STRING PRETTY</option>
                        <option value="4">JSON TO STRING NOZERO</option>
                    </select>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            serverAddressError: false,
            portNumberError: false,
            ftpServerAddressError: false,
            ftpPortNumberError: false
        }
    },
    props: ['serverData'],
    methods: {
        validateServerAddress() {
            if(/^\d{1,3}.\d{1,3}.\d{1,3}.\d{1,3}$/.test(this.serverData.mqtt.hostname) || /(\w+\.\w*\.?)+/.test(this.serverData.mqtt.hostname) || this.serverData.mqtt.hostname === 'NULL') {
                this.serverAddressError = false
            } else {
                this.serverAddressError = true
            }
        },
        validatePort() {
            if((/^[0-9]+$/.test(this.serverData.mqtt.portNumber) && (parseInt(this.serverData.mqtt.portNumber) > 0 && parseInt(this.serverData.mqtt.portNumber) < 65536)) || this.serverData.mqtt.portNumber === 'NULL') {
                this.portNumberError = false
            } else {
                this.portNumberError = true
            }
        },
        validateFtpServerAddress() {
            if(/^\d{1,3}.\d{1,3}.\d{1,3}.\d{1,3}$/.test(this.serverData.mqtt.ftpServerAddress) || this.serverData.mqtt.ftpServerAddress === 'NULL') {
                this.ftpServerAddressError = false
            } else {
                this.ftpServerAddressError = true
            }
        },
        validateFtpPort() {
            if((/^[0-9]+$/.test(this.serverData.mqtt.ftpPortNumber) && (parseInt(this.serverData.mqtt.ftpPortNumber) > 0 && parseInt(this.serverData.mqtt.ftpPortNumber) < 65536)) || this.serverData.mqtt.ftpPortNumber === 'NULL') {
                this.ftpPortNumberError = false
            } else {
                this.ftpPortNumberError = true
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/server-forms/MqttDetails.vue